var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refbtn",class:_vm.setClass(),attrs:{"id":_vm.setId()},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.code ? _vm.codeText : _vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }